
import { Component, Inject, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import CategoriesFilter from "../../conference/CategoriesFilter.vue";
import { ConferenceFilterStore } from "../../../stores/conference/ConferenceFilterStore";
import FilterHeader from "../filters/FilterHeader.vue";

@Component({
    components: {
        FilterHeader,
        CategoriesFilter,
    },
})
export default class GlobalEventsSidebar extends Vue {
    @Inject("container") readonly container!: Container;
    filterStore: ConferenceFilterStore = this.container.get(ConferenceFilterStore);
}
